package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class AppVersionResponse(
    val platform: String,
    val latestVersion: String,
    val minVersion: String,
    val updateRequired: Boolean,
    val updateAvailable: Boolean,
    val updateUrl: String,
    val releaseNotes: String? = null
)

enum class UpdateType {
    NONE,           // No update needed
    OPTIONAL,       // Update available but not required
    REQUIRED        // Must update to continue using app
}

data class UpdateCheckResult(
    val updateType: UpdateType,
    val currentVersion: String,
    val latestVersion: String,
    val updateUrl: String,
    val releaseNotes: String? = null
)
